import CapexMetricConfigurationPage from "@Quest/Metrics/Pages/CapexMetricConfigurationPage.vue";
import CostSubtotalMetricConfigurationPage from "@Quest/Metrics/Pages/CostSubtotalMetricConfigurationPage.vue";
import ExpenseMetricConfigurationPage from "@Quest/Metrics/Pages/ExpenseMetricConfigurationPage.vue";
import MarginCogsMetricConfigurationPage from "@Quest/Metrics/Pages/MarginCogsMetricConfigurationPage.vue";
import MetricsPage from "@Quest/Metrics/Pages/MetricsPage.vue";
import ResourceCostMetricConfigurationPage from "@Quest/Metrics/Pages/ResourceCostMetricConfigurationPage.vue";
import ResourceMetricConfigurationPage from "@Quest/Metrics/Pages/ResourceMetricConfigurationPage.vue";
import RevenueMetricConfigurationPage from "@Quest/Metrics/Pages/RevenueMetricConfigurationPage.vue";
import TotalCostMetricConfigurationPage from "@Quest/Metrics/Pages/TotalCostMetricConfigurationPage.vue";
import OpexMetricConfigurationPage from "@Quest/Metrics/Pages/OpexMetricConfigurationPage.vue";

export const routes = [
    {
        path: "/enterprise/metrics/:workspaceId/:strategyId",
        component: MetricsPage
    },

    {
        path: "/enterprise/create-resource-metric/:workspaceId/:strategyId",
        component: ResourceMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-resource-metric/:workspaceId/:strategyId/:metricId",
        component: ResourceMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-resource-metric/:workspaceId/:strategyId/:metricId",
        component: ResourceMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-resource-cost-metric/:workspaceId/:strategyId",
        component: ResourceCostMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-resource-cost-metric/:workspaceId/:strategyId/:metricId",
        component: ResourceCostMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-resource-cost-metric/:workspaceId/:strategyId/:metricId",
        component: ResourceCostMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-revenue-metric/:workspaceId/:strategyId",
        component: RevenueMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-revenue-metric/:workspaceId/:strategyId/:metricId",
        component: RevenueMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-revenue-metric/:workspaceId/:strategyId/:metricId",
        component: RevenueMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-expense-metric/:workspaceId/:strategyId",
        component: ExpenseMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-expense-metric/:workspaceId/:strategyId/:metricId",
        component: ExpenseMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-expense-metric/:workspaceId/:strategyId/:metricId",
        component: ExpenseMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-margin-cogs-metric/:workspaceId/:strategyId",
        component: MarginCogsMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-margin-cogs-metric/:workspaceId/:strategyId/:metricId",
        component: MarginCogsMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-margin-cogs-metric/:workspaceId/:strategyId/:metricId",
        component: MarginCogsMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-total-cost-metric/:workspaceId/:strategyId",
        component: TotalCostMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-total-cost-metric/:workspaceId/:strategyId/:metricId",
        component: TotalCostMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-total-cost-metric/:workspaceId/:strategyId/:metricId",
        component: TotalCostMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

    {
        path: "/enterprise/create-capex-metric/:workspaceId/:strategyId",
        component: CapexMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-capex-metric/:workspaceId/:strategyId/:metricId",
        component: CapexMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-capex-metric/:workspaceId/:strategyId/:metricId",
        component: CapexMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },


    {
        path: "/enterprise/create-cost-subtotal-metric/:workspaceId/:strategyId",
        component: CostSubtotalMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-cost-subtotal-metric/:workspaceId/:strategyId/:metricId",
        component: CostSubtotalMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-cost-subtotal-metric/:workspaceId/:strategyId/:metricId",
        component: CostSubtotalMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },


    {
        path: "/enterprise/create-opex-metric/:workspaceId/:strategyId",
        component: OpexMetricConfigurationPage,
        meta: { mode: 'Creator' }
    },
    {
        path: "/enterprise/edit-opex-metric/:workspaceId/:strategyId/:metricId",
        component: OpexMetricConfigurationPage,
        meta: { mode: 'Editor' }
    },
    {
        path: "/enterprise/clone-opex-metric/:workspaceId/:strategyId/:metricId",
        component: OpexMetricConfigurationPage,
        meta: { mode: 'Cloner' }
    },

]
